export default "__VITE_ASSET__e944edb7__"